import Swal from "sweetalert2";
import { apiV2, errorHandler } from "./index";
import {
  FETCH_ALL_DAILY_REFLECTIONS,
  API_ERROR,
  FETCH_ALL_GENERAL_DATA,
  DELETE_DAILY_REFLECTION_SUCCESS,
  SAVE_DAILY_REFLECTION_SUCCESS,
  SAVE_DAILY_REFLECTION_ERROR,
  DELETE_DAILY_REFLECTION_ERROR,
  FETCH_ALL_DAILY_REFLECTIONS_SUCCESS,
  SAVE_DAILY_REFLECTION,
  FETCH_ALL_DAILY_REFLECTIONS_ERROR,
  FETCH_ONE_DAILY_REFLECTION,
  FETCH_ONE_DAILY_REFLECTION_SUCCESS,
  FETCH_ONE_DAILY_REFLECTION_ERROR,
  CLOSE_DAILY_REFLECTION_FORM,
} from "../constants/ActionTypes";

export function fetchAllDailyReflections() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_DAILY_REFLECTIONS
    });

    apiV2.get('/daily-inspirations')
      .then((response) => {
        dispatch({
          type: FETCH_ALL_DAILY_REFLECTIONS_SUCCESS,
          payload: response.data.objects,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ALL_DAILY_REFLECTIONS_ERROR
        })
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function addEditDailyReflections(daily_reflection_json, onSuccess) {
  return function (dispatch) {
    dispatch({
      type: SAVE_DAILY_REFLECTION
    });

    const {
      title,
      day,
      date_epoch,
      schedule_month,
      schedule_day,
      is_seasonal,
      is_premium,
      audio_length,
      audio_url,
      image_url,
      author_id,
      deeplink_url,
      deeplink_image_url,
    } = daily_reflection_json;

    /* Daily Inspirations switched to a perpetual (schedule_month, schedule_day)
     * schedule (Monday 12107892350 / APIv2 PR #583). We send the new fields
     * as the source of truth; date_epoch is left in the payload for the
     * transition so APIv1 (which deploys independently) keeps having a
     * value to write. The APIv2 service back-fills date_epoch from
     * (month, day) when needed, and back-fills (month, day) from date_epoch
     * for legacy callers, so either side works regardless of which API
     * deploys first. */
    const payload = {
      title,
      day,
      date_epoch,
      schedule_month,
      schedule_day,
      is_seasonal: is_seasonal ? 1 : 0,
      is_premium,
      audio_length,
      audio_url,
      image_url,
      author_id,
      deeplink_url,
      deeplink_image_url,
    };

    const request = daily_reflection_json.daily_reflection_id
      ? apiV2.put(`/daily-inspirations/${daily_reflection_json.daily_reflection_id}`, payload)
      : apiV2.post('/daily-inspirations', payload);

    request
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Saved!",
          timer: 1000,
        }).then(() => {
          dispatch({
            type: SAVE_DAILY_REFLECTION_SUCCESS,
            payload: daily_reflection_json
          });
          onSuccess?.();
        });
      })
      .catch((error) => {
        dispatch({
          type: SAVE_DAILY_REFLECTION_ERROR,
        });
        Swal.fire({
          icon: "error",
          title: error.response?.data?.message || 'An error occurred',
          heightAuto: true,
        });
      });
  };
}

export function deleteDailyReflection(daily_reflection_id, onSuccess) {
  return function (dispatch) {
    apiV2.delete(`/daily-inspirations/${daily_reflection_id}`)
      .then((response) => {
        Swal.fire({
          icon: "success",
          title: "Deleted Successfully!",
          timer: 1000,
        }).then(() => {
          dispatch({
            type: DELETE_DAILY_REFLECTION_SUCCESS,
            payload: daily_reflection_id
          });
          onSuccess?.();
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_DAILY_REFLECTION_ERROR,
          payload: daily_reflection_id
        });
        Swal.fire({
          icon: "error",
          title: error.response?.data?.message || 'An error occurred',
          heightAuto: true,
        });
      });
  };
}

export function fetchDailyInspirationDescription() {
  return function (dispatch) {
    apiV2.get('/daily-inspirations/description')
      .then((response) => {
        dispatch({
          type: FETCH_ALL_GENERAL_DATA,
          payload: response.data,
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function updateDailyInspirationDescription(
  daily_inspiration_description,
  onSuccess
) {
  return async function (dispatch) {
    try {
      await apiV2.put('/daily-inspirations/description', {
        daily_inspiration_description,
      });
      onSuccess?.();
      Swal.fire({
        icon: "success",
        title: "Saved!",
        timer: 1000,
      });
    } catch (error) {
      errorHandler(dispatch, error.response, API_ERROR);
    }
  };
}

export function fetchOneDailyReflection(daily_reflection_id) {
  return function (dispatch) {
    dispatch({
      type: FETCH_ONE_DAILY_REFLECTION
    });

    apiV2.get(`/daily-inspirations/${daily_reflection_id}`)
      .then((response) => {
        dispatch({
          type: FETCH_ONE_DAILY_REFLECTION_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ONE_DAILY_REFLECTION_ERROR
        })
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function closeDailyReflectionForm() {
  return function (dispatch) {
    dispatch({
      type: CLOSE_DAILY_REFLECTION_FORM
    });
  };
}
